import { Sport } from '@hulanbv/toftennis';

const sportLabels: Record<Sport, string> = {
  [Sport.TENNIS]: 'Tennis',
  [Sport.PADEL]: 'Padel',
  [Sport.WHEELCHAIR_TENNIS]: 'Rolstoeltennis',
};

export { sportLabels };
